import {GolferDetail} from "../helpers/golferFields";
import {generateUID} from "../helpers/codeGenerator";
import firebase from "firebase/compat";
import {ISelectedOptionSet} from "./IOptionSet";

export interface IOrderBasketItem {
    orderId?: string,
    menuItemId?: string,
    categoryId?: string,
    name?: string,
    quantity: number,
    basePrice: number,
    unitPrice: number,
    lineTotal: number,
    specialInstruction?: string,
    selectedOptions: ISelectedOptionSet[]
}

export interface IOrderInfo {
    golferDetails?: GolferDetail[],
    phone: string,
    email: string,
    name?: string,
    basketItems: Array<IOrderBasketItem>,
    basketPrice: number,
    tip: number,
    courseId: string,
    section?: string,
    onCourse: boolean,
    hole?: number,
    courseReference?: firebase.firestore.DocumentReference,
    state: string,
    paymentMethod: number,
    paid: boolean,
    refCode?: string,
    createdDate: number,
    updatedDate?: number,
    isDeleted: boolean
}

export const createOrderPayload = (phone: string,
                                   email: string,
                                   name: string,
                                   basketItems: Array<IOrderBasketItem>,
                                   basketPrice: number,
                                   tip: number,
                                   courseId: string,
                                   section: string,
                                   onCourse: boolean,
                                   hole: number | undefined,
                                   paymentMethod: number,
                                   paid: boolean): IOrderInfo => {
    const refCode = `${generateUID(4)}-${generateUID(4)}`;

    return {
        phone,
        email,
        name,
        basketItems,
        basketPrice,
        tip,
        courseId,
        section,
        onCourse,
        ...(hole === undefined ? {} : {hole}),
        state: 'New',
        paymentMethod,
        paid,
        refCode,
        createdDate: Date.now(), // Gets the current date in Milliseconds. Used to order on Firebase when Querying
        isDeleted: false
    };
}
